import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';

import { UserRepository } from '../../user.repository';
import { NotifyService, ToastType } from 'app/notify';
import { HTTP_STATUS_CODE } from 'app/shared/http-status-code.enum';
import { AppValidators } from 'app/shared/custom-validators/app-validators';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit, OnDestroy {

  public newPasswordForm: FormGroup;

  private updateValuesSubscription: Subscription = null;
  private token: string = '';

  constructor(
    private userRepository: UserRepository,
    private formBuilder: FormBuilder,
    activatedRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private notify: NotifyService
  ) {
    this.token = activatedRoute.snapshot.params['token'];
  }

  ngOnInit() {
    this.createNewPasswordForm();
  }

  ngOnDestroy() {
    if (this.updateValuesSubscription !== null) {
      this.updateValuesSubscription.unsubscribe();
    }
  }

  setPassword({ valid, value }) {
    if (!valid) {
      return;
    }

    this.userRepository.setNewPassword(value.password, this.token).subscribe(
      () => {
        this.newPasswordForm.reset();
        this.router.navigate(['login']);
        this.notify.toast(ToastType.SUCCESS, this.translateService.instant('user.reset_password.messages.password_succes'));
      },
      (error) => {
        const errorResponse = error.json();
        if (error.status === HTTP_STATUS_CODE.NOT_FOUND) {
          this.newPasswordForm.reset();
          this.notify.toast(ToastType.ERROR, this.translateService.instant('user.reset_password.messages.badUrl'));
          this.router.navigate(['login']);

          return;
        }
        this.newPasswordForm.reset();
        this.notify.toast(ToastType.ERROR, this.translateService.instant('user.reset_password.messages.tokenUsed'));
        this.router.navigate(['login']);
      }
    );
  }

  private createNewPasswordForm(): void {
    this.newPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(5)]],
      reenteredPassword: ['']
    });

    this.newPasswordForm.get('reenteredPassword').setValidators(
      AppValidators.identical(this.newPasswordForm.get('password'))
    );

    this.updateValuesSubscription = this.newPasswordForm.get('password').valueChanges.subscribe(() => {
      this.newPasswordForm.get('reenteredPassword').updateValueAndValidity();
    });
  }

}



// WEBPACK FOOTER //
// /dist/src/app/user/reset-password/new-password/new-password.component.ts